import styles from "./FAQ.module.css";

function FAQCard({ img, user, question, answer }) {
  return (
    <div className={styles.card}>
      <img src={img} alt={question} />

      <p className={styles.user}>{user}</p>

      <h3>{question}</h3>

      <p className={styles.answer}>{answer}</p>
    </div>
  );
}

export default FAQCard;
